import { render, staticRenderFns } from "./TestResults.vue?vue&type=template&id=0a9c5956&scoped=true"
import script from "./TestResults.vue?vue&type=script&lang=js"
export * from "./TestResults.vue?vue&type=script&lang=js"
import style0 from "./TestResults.vue?vue&type=style&index=0&id=0a9c5956&prod&scoped=true&lang=css"
import style1 from "./TestResults.vue?vue&type=style&index=1&id=0a9c5956&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9c5956",
  null
  
)

export default component.exports